<template>
  <b-card class="shadow-sm">
    <b-card-body class="mb-4 px-6 pt-6">
      <!-- LOADING -->
      <div v-if="loading">
        <b-row class="text-center">
          <div class="col-6 border-right">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
          <div class="col-6">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
        </b-row>
      </div>

      <!-- CONTEÚDO -->
      <div v-else>
        <b-row class="text-center">
          <div
            class="col-6 border-right"
            style="cursor: pointer"
            @click="$router.push({ name: 'pessoasLista' })"
          >
            <b-card-title class="mb-5">
              <b-icon icon="people-fill" variant="primary" class="mr-2" />
              Pessoas
            </b-card-title>
            <h2 class="display-4 text-primary mb-0 font-weight-bold">
              {{ pessoas }}
            </h2>
          </div>

          <div
            class="col-6"
            style="cursor: pointer"
            @click="$router.push({ name: 'produtosLista' })"
          >
            <b-card-title class="mb-5 totalizador-produtos-title" @click.stop>
              <b-icon icon="tags-fill" variant="primary" class="mr-2" />
              <b-dropdown
                variant="link"
                toggle-class="p-0 text-secondary font-weight-bold dashboard-title-dropdown"
                menu-class="dashboard-title-menu"
                no-caret
              >
                <template #button-content>
                  <span
                    class="dashboard-title-label"
                    :class="{
                      'dashboard-title-label-sm':
                        produtoSelecionado === 'produtos_estoque',
                    }"
                  >
                    {{ produtoSelecionadoLabel }}
                  </span>
                  <b-icon icon="chevron-down" class="dashboard-title-icon" />
                </template>
                <b-dropdown-item
                  :active="produtoSelecionado === 'produtos'"
                  @click="produtoSelecionado = 'produtos'"
                >
                  Produtos
                </b-dropdown-item>
                <b-dropdown-item
                  :active="produtoSelecionado === 'produtos_estoque'"
                  @click="produtoSelecionado = 'produtos_estoque'"
                >
                  Produtos em Estoque
                </b-dropdown-item>
              </b-dropdown>
            </b-card-title>
            <h2 class="display-4 text-primary mb-0 font-weight-bold">
              {{ produtos }}
            </h2>
          </div>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "TotalizadorCadastros",
  data() {
    return {
      produtoSelecionado: "produtos",
    };
  },
  props: {
    totaisCadastros: {
      type: Object,
      default: () => ({ produtos: 0, pessoas: 0 }),
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    pessoas() {
      return Number(this.totaisCadastros?.pessoas ?? 0);
    },
    produtoSelecionadoLabel() {
      return this.produtoSelecionado === "produtos_estoque"
        ? "Produtos em Estoque"
        : "Produtos";
    },
    produtos() {
      return Number(
        this.totaisCadastros?.[this.produtoSelecionado] ??
          this.totaisCadastros?.produtos ??
          0
      );
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: rgba(0, 123, 255, 0.05); /* leve destaque */
  transition: background-color 0.2s ease;
}

::v-deep .dashboard-title-dropdown {
  color: #6c7293 !important;
  font-size: inherit;
  line-height: inherit;
  text-decoration: none !important;
  vertical-align: baseline;
}

::v-deep .dashboard-title-dropdown:hover,
::v-deep .dashboard-title-dropdown:focus {
  color: #f36f61 !important;
  text-decoration: none !important;
  box-shadow: none;
}

::v-deep .dashboard-title-menu .dropdown-item.active {
  background-color: #f36f61;
}

.totalizador-produtos-title {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 24px;
}

::v-deep .dashboard-title-dropdown .dropdown-toggle {
  align-items: center;
  display: inline-flex;
  max-width: 150px;
}

.dashboard-title-label {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-title-label-sm {
  font-size: 0.95rem;
  line-height: 1.15;
}

.dashboard-title-icon {
  flex-shrink: 0;
  margin-left: 4px;
}
</style>
